// HomePage.jsx
import React, { useState, useCallback, useEffect } from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { ProblemSolutionSection } from '../components/home/ProblemSolutionSection';
import { GoProactiveSection } from '../components/home/GoProactiveSection';
import { FeatureShowcase } from '../components/home/FeatureShowcase';
import { LaborWasteCalculator } from '../components/home/LaborWasteCalculator';
import { CTASection } from '../components/home/CTASection';
import { YourInfra } from '../components/home/YourInfra';
import { ContactModal } from '../components/home/ContactSection';

export function HomePage() {
  const [contactOpen, setContactOpen] = useState(false);
  const openContact = useCallback(() => setContactOpen(true), []);

  useEffect(() => {
    const handler = () => setContactOpen(true);
    window.addEventListener('open-contact-modal', handler);
    return () => window.removeEventListener('open-contact-modal', handler);
  }, []);

  return (
    <div>
      <HeroSection />
      <ProblemSolutionSection />
      <GoProactiveSection />
      <FeatureShowcase />
      <LaborWasteCalculator />
      <CTASection onOpenContact={openContact} />
      <YourInfra />
      <ContactModal isOpen={contactOpen} onClose={() => setContactOpen(false)} />
    </div>
  );
}
